import React, { useState, useEffect } from 'react';
import { settings as settingsApi } from '../services/api';
import './ConfigSFTP.css';

const FIELDS = [
  { key: 'sftp_or_en_cours_path',        label: 'OR en cours',                   placeholder: '/OR En Cours.csv' },
  { key: 'sftp_garantie_path',            label: 'Garantie',                      placeholder: '/Garantie.all.csv' },
  { key: 'sftp_factures_services_path',   label: 'Factures services',             placeholder: '/Ateliers.all.csv' },
  { key: 'sftp_recouvrement_path',        label: 'Recouvrement',                  placeholder: '/Recouvrements.all.csv' },
  { key: 'sftp_carnet_commande_path',     label: 'Carnet de commande (Pièces)',   placeholder: '/PIECES/Carnet-de-commande.xls' },
  { key: 'sftp_mecaplanning_path',        label: 'Mécaplanning',                  placeholder: '/Mecaplanning.csv' },
  { key: 'sftp_roole_actifs_path',       label: 'Roole actifs',                  placeholder: '/ROOLE/membres_actifs.csv' },
  { key: 'sftp_clients_datacar_path',   label: 'Clients Datacar',               placeholder: '/Clients.all.csv' },
  { key: 'sftp_sigar_path',             label: 'Sigar',                         placeholder: '/sigar.all.csv' },
  { key: 'sftp_stock_vo_path',           label: 'Stock VO',                      placeholder: '/stockvo.all.csv' },
  { key: 'sftp_stock_vn_path',           label: 'Stock VN',                      placeholder: '/stockvn.all.csv' },
  { key: 'sftp_stock_pieces_path',       label: 'Stock Pièces',                  placeholder: '/stk.pda.all.csv' },
  { key: 'sftp_ventes_vn_path',          label: 'Ventes VN',                     placeholder: '/vtes.vn.détail.all.csv' },
  { key: 'sftp_ventes_vo_path',          label: 'Ventes VO',                     placeholder: '/Vtes.vo.detail.all.csv' },
  { key: 'sftp_passages_path',           label: 'Passages atelier (Relances)',   placeholder: '/Passages.ate.all.csv' },
  { key: 'sftp_vn_jamais_revenus_path',  label: 'VN jamais revenus (Relances)',  placeholder: '/VN.jamais.revenus.all.csv' },
  { key: 'sftp_jdma_dir',                label: 'JDMA — dossier avis clients',   placeholder: '/JDMA' },
];

export default function ConfigSFTP() {
  const [values, setValues]     = useState({});
  const [host, setHost]         = useState('');
  const [sftpUser, setSftpUser] = useState('');
  const [loading, setLoading]   = useState(true);
  const [editing, setEditing]   = useState({}); // { [key]: true } quand en édition
  const [draft, setDraft]       = useState({});  // valeurs temporaires pendant l'édition
  const [saving, setSaving]     = useState({});  // { [key]: true } pendant la sauvegarde
  const [msg, setMsg]           = useState({});  // { [key]: { type, text } }

  useEffect(() => {
    settingsApi.getSftp().then(res => {
      const d = res.data;
      setHost(d.sftp_host || '');
      setSftpUser(d.sftp_user || '');
      const v = {};
      FIELDS.forEach(f => { v[f.key] = d[f.key] || ''; });
      setValues(v);
      setDraft(v);
    }).catch(e => {
      setMsg({ _global: { type: 'err', text: e.response?.data?.error || 'Erreur de chargement' } });
    }).finally(() => setLoading(false));
  }, []);

  const startEdit = (key) => {
    setDraft(prev => ({ ...prev, [key]: values[key] }));
    setEditing(prev => ({ ...prev, [key]: true }));
    setMsg(prev => ({ ...prev, [key]: null }));
  };

  const cancelEdit = (key) => {
    setEditing(prev => ({ ...prev, [key]: false }));
    setDraft(prev => ({ ...prev, [key]: values[key] }));
  };

  const saveField = async (key) => {
    setSaving(prev => ({ ...prev, [key]: true }));
    setMsg(prev => ({ ...prev, [key]: null }));
    try {
      await settingsApi.updateSftp({ [key]: draft[key] });
      setValues(prev => ({ ...prev, [key]: draft[key] }));
      setEditing(prev => ({ ...prev, [key]: false }));
      setMsg(prev => ({ ...prev, [key]: { type: 'ok', text: 'Enregistré.' } }));
      setTimeout(() => setMsg(prev => ({ ...prev, [key]: null })), 3000);
    } catch (e) {
      setMsg(prev => ({ ...prev, [key]: { type: 'err', text: e.response?.data?.error || 'Erreur' } }));
    } finally {
      setSaving(prev => ({ ...prev, [key]: false }));
    }
  };

  if (loading) return <div className="sftp-config-loading">Chargement…</div>;

  return (
    <div className="sftp-config">
      <h2 className="sftp-config-title">⚙️ Configuration SFTP</h2>
      <p className="sftp-config-subtitle">
        Gérez les chemins des fichiers synchronisés depuis le serveur SFTP.<br />
        Les identifiants de connexion (hôte, utilisateur, mot de passe) restent dans la configuration serveur.
      </p>

      <div className="sftp-config-readonly">
        <div className="sftp-config-readonly-row">
          <span className="sftp-config-readonly-label">🌐 Hôte SFTP</span>
          <span className="sftp-config-readonly-value">{host || '—'}</span>
        </div>
        <div className="sftp-config-readonly-row">
          <span className="sftp-config-readonly-label">👤 Utilisateur</span>
          <span className="sftp-config-readonly-value">{sftpUser || '—'}</span>
        </div>
      </div>

      <div className="sftp-config-section-title">Chemins des fichiers</div>
      <div className="sftp-config-fields">
        {FIELDS.map(f => {
          const isEditing = !!editing[f.key];
          const isSaving  = !!saving[f.key];
          const fieldMsg  = msg[f.key];
          return (
            <div className="sftp-config-field" key={f.key}>
              <div className="sftp-config-field-header">
                <label className="sftp-config-label">{f.label}</label>
                {!isEditing && (
                  <button className="sftp-config-btn-edit" onClick={() => startEdit(f.key)}>
                    ✏️ Modifier
                  </button>
                )}
              </div>

              {isEditing ? (
                <div className="sftp-config-edit-row">
                  <input
                    className="sftp-config-input"
                    type="text"
                    value={draft[f.key] || ''}
                    placeholder={f.placeholder}
                    autoFocus
                    onChange={e => setDraft(prev => ({ ...prev, [f.key]: e.target.value }))}
                    onKeyDown={e => { if (e.key === 'Enter') saveField(f.key); if (e.key === 'Escape') cancelEdit(f.key); }}
                  />
                  <button className="sftp-config-btn-save-field" onClick={() => saveField(f.key)} disabled={isSaving}>
                    {isSaving ? '…' : '✓'}
                  </button>
                  <button className="sftp-config-btn-cancel" onClick={() => cancelEdit(f.key)} disabled={isSaving}>
                    ✕
                  </button>
                </div>
              ) : (
                <div className="sftp-config-value">{values[f.key] || <span className="sftp-config-empty">{f.placeholder}</span>}</div>
              )}

              {fieldMsg && (
                <div className={`sftp-config-field-msg sftp-config-field-msg-${fieldMsg.type}`}>
                  {fieldMsg.type === 'ok' ? '✅' : '❌'} {fieldMsg.text}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {msg._global && (
        <div className={`sftp-config-msg sftp-config-msg-${msg._global.type}`}>
          ❌ {msg._global.text}
        </div>
      )}
    </div>
  );
}
